// Add your custom JS here.

// Reset links to default state after clicked
// Bootstrap defaults to leaving links in focus state after clicking
// =================================================================
window.addEventListener('DOMContentLoaded', function() {
	jQuery("a").click(function (e) {
		jQuery(this).blur();
	});
});

// Menu functionality & tweaks
// ===========================
window.addEventListener('DOMContentLoaded', function() {

	jQuery(function($) {
		// Show page overlay when (desktop) opens
		$('#mega-menu-primary li.mega-menu-item').on('open_panel', function() {
			$('#page-overlay').removeClass("d-none");
		});
		// Hide page overlay when (desktop) closes
		$('#mega-menu-primary li.mega-menu-item').on('close_panel', function() {
			$('#page-overlay').addClass("d-none");
		});
		// Close menu when ESC pressed
		$(document).keyup(function(e) {
			if (e.keyCode === 27) {
				$('#mega-menu-primary').data('maxmegamenu').hideAllPanels();
			}
		});
	});
	
	// Disable tab-focus on 2nd-level menu items (aka "sub-menu titles")
	document.querySelectorAll('.no-tab > a').forEach((element) => {
		element.setAttribute("tabindex", "-1");
	});
	// Disable tab-focus
	document.querySelectorAll('#mobile-menu-xtra-content > a.mega-menu-link').forEach((element) => {
		element.setAttribute("tabindex", "-1");
	});

});

// Force page-level anchors to scroll to the correct position on first click
// =========================================================================
window.addEventListener('load', function () {
	jQuery('a').click(function( e ){
		var theTarget = jQuery(this).attr('href');
		if (typeof theTarget !== "undefined") {
			if ( theTarget.startsWith("#") == true && theTarget.length > 1 ) {
				var windowWidth = jQuery( window ).width();
				if ( windowWidth >= 768) {
					var scrollOffset = 140;
				} else {
					var scrollOffset = 20;
				}
				jQuery('html, body').animate({
					scrollTop: jQuery(theTarget).offset().top - scrollOffset
				}, 100);
			}
		}
	});
});